import { render, staticRenderFns } from "./hak_otorisasi.vue?vue&type=template&id=d6e57622&scoped=true"
import script from "./hak_otorisasi.vue?vue&type=script&lang=js"
export * from "./hak_otorisasi.vue?vue&type=script&lang=js"
import style0 from "./hak_otorisasi.vue?vue&type=style&index=0&id=d6e57622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e57622",
  null
  
)

export default component.exports